/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { bootstrapGlobalRender } from 'src/core/utils/bootstrap/bootstrapGlobalRender';
import { bootstrapGlobalState } from 'src/core/utils/bootstrap/bootstrapGlobalState';

const dependencies = bootstrapGlobalState();
bootstrapGlobalRender(dependencies);
